// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Tournament Rules Tab CSS Module
 * Styles for tournament rules and information display
 * Aligned with PrizePop RulesTab styling
 */
.Rzq8v3HN2X85fDiC5em3 {
  width: 100%;
  max-width: var(--campaign-tab-width);
  margin: 0 auto 10px;
  flex: 1;
  overflow-y: auto;
}
.lXFAfGQuvOkcoyopgmKn {
  height: 200px;
  width: 100%;
  position: relative;
  display: block;
}
.vFfsnAor04ShKuwVDLkV {
  border-radius: 12px;
  overflow: hidden;
  padding: 1px;
}
.mwCguRDoT3d4H_byub1Y {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 14px;
  background-color: #212121;
  border-radius: 12px;
  visibility: visible;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(39, 39, 39, 0.5);
  box-sizing: border-box;
}
.Ao8zN5hBrJxEGImTs01u {
  color: #d4d4d4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
  letter-spacing: 0.18px;
  gap: 14px;
  font-size: 21px;
  width: 90%;
  height: auto;
  line-height: 1.3;
}
.Ao8zN5hBrJxEGImTs01u > div:first-child .G9483DMANHPStOMHl1tt {
  margin-top: -7px;
}
.G9483DMANHPStOMHl1tt {
  font-weight: bold;
}
.IK5CevRzk_i_5hV5CoRk {
  margin-top: 5px;
  font-weight: normal;
  text-align: left;
}
.wBg4fTATs6vpuvz1zROn {
  font-weight: bold;
  color: #FFDF1A;
}
.sNMfcH1Vx43lL9RDRcGC {
  align-self: flex-start;
  cursor: pointer;
  position: relative;
}
/* Styles for FormulaRules component */
.Zr_Bi4WmxH96x2IXZeNT {
  list-style-type: disc;
  padding-left: 1.25rem;
  padding-top: 4px;
}
.PttwSJIBndMaCdZRox9H {
  font-weight: bold;
  color: #FFDF1A;
}
.lke_QCnknQn7EvnRfPhv {
  white-space: nowrap;
}
.x1Bw2JTk6XqgUACmrBFA {
  display: block;
  font-style: italic;
  font-weight: 300;
  padding-top: 4px;
}
.DIfkV0TPYRpUnTjrSicD {
  padding-top: 4px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .mwCguRDoT3d4H_byub1Y {
    padding: 8.5px;
  }
  .Ao8zN5hBrJxEGImTs01u {
    font-size: 15px;
  }
  .Ao8zN5hBrJxEGImTs01u > div:first-child .G9483DMANHPStOMHl1tt {
    margin-top: -5px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (orientation: portrait) and (max-color:2147477350) {
  .mwCguRDoT3d4H_byub1Y,
  .vFfsnAor04ShKuwVDLkV {
    border-radius: 8px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (orientation: portrait) and (color:2147477350) {
  .mwCguRDoT3d4H_byub1Y,
  .vFfsnAor04ShKuwVDLkV {
    border-radius: 8px;
  }
}
}
}
}
/* TermsInfoModal styles */
.pmyvemWcAl7ecust2SPQ {
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #2e2e2e;
  z-index: 98;
}
.fNq2gi_Ryjxg1_AgArFQ {
  width: 100%;
  height: calc(100vh - 50px);
  gap: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #262626;
  margin-top: 50px;
  overflow-y: auto;
}
.rAWgNd9KQqswEDRARB1g {
  font-size: 14px;
  font-weight: bold;
  line-height: 16.41px;
  text-align: center;
  color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: var(--font-family-primary);
}
.kVCsPeC1xhOAPIc8Lvfv {
  color: white;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.5;
  text-align: left;
  padding: 10px 20px;
  font-family: var(--font-family-primary);
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 90%;
  margin: 0 auto;
}
.Gfwjf1ThzcKUndvrFWeB {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  z-index: 101;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background-color: #48494b;
  padding: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/tournaments/tabs/RulesTab/TournamentRulesTab.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;AAAA;EACE;;IAEE,kBAAkB;EACpB;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;;IAEE,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA;AACA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd","sourcesContent":["/**\n * Tournament Rules Tab CSS Module\n * Styles for tournament rules and information display\n * Aligned with PrizePop RulesTab styling\n */\n.rulesWrapper {\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  margin: 0 auto 10px;\n  flex: 1;\n  overflow-y: auto;\n}\n.loaderContainer {\n  height: 200px;\n  width: 100%;\n  position: relative;\n  display: block;\n}\n.contentContainerWrapper {\n  border-radius: 12px;\n  overflow: hidden;\n  padding: 1px;\n}\n.contentContainer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 14px;\n  background-color: #212121;\n  border-radius: 12px;\n  visibility: visible;\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(39, 39, 39, 0.5);\n  box-sizing: border-box;\n}\n.textSection {\n  color: #d4d4d4;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: left;\n  letter-spacing: 0.18px;\n  gap: 14px;\n  font-size: 21px;\n  width: 90%;\n  height: auto;\n  line-height: 1.3;\n}\n.textSection > div:first-child .title {\n  margin-top: -7px;\n}\n.title {\n  font-weight: bold;\n}\n.description {\n  margin-top: 5px;\n  font-weight: normal;\n  text-align: left;\n}\n.highlightedText {\n  font-weight: bold;\n  color: #FFDF1A;\n}\n.infoIcon {\n  align-self: flex-start;\n  cursor: pointer;\n  position: relative;\n}\n/* Styles for FormulaRules component */\n.list {\n  list-style-type: disc;\n  padding-left: 1.25rem;\n  padding-top: 4px;\n}\n.highlightedTextRules {\n  font-weight: bold;\n  color: #FFDF1A;\n}\n.noWrap {\n  white-space: nowrap;\n}\n.italicText {\n  display: block;\n  font-style: italic;\n  font-weight: 300;\n  padding-top: 4px;\n}\n.styledSpan {\n  padding-top: 4px;\n}\n@media (--campaign-mobile) {\n  .contentContainer {\n    padding: 8.5px;\n  }\n  .textSection {\n    font-size: 15px;\n  }\n  .textSection > div:first-child .title {\n    margin-top: -5px;\n  }\n}\n@media (orientation: portrait) and (--campaign-mobile) {\n  .contentContainer,\n  .contentContainerWrapper {\n    border-radius: 8px;\n  }\n}\n/* TermsInfoModal styles */\n.modalContainer {\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #2e2e2e;\n  z-index: 98;\n}\n.modalContentWrapper {\n  width: 100%;\n  height: calc(100vh - 50px);\n  gap: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: #262626;\n  margin-top: 50px;\n  overflow-y: auto;\n}\n.modalTitle {\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 16.41px;\n  text-align: center;\n  color: white;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-family: var(--font-family-primary);\n}\n.termsText {\n  color: white;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.5;\n  text-align: left;\n  padding: 10px 20px;\n  font-family: var(--font-family-primary);\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-width: 90%;\n  margin: 0 auto;\n}\n.closeModalIcon {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  z-index: 101;\n  width: 40px;\n  height: 40px;\n  border-radius: 6px;\n  background-color: #48494b;\n  padding: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rulesWrapper": `Rzq8v3HN2X85fDiC5em3`,
	"loaderContainer": `lXFAfGQuvOkcoyopgmKn`,
	"contentContainerWrapper": `vFfsnAor04ShKuwVDLkV`,
	"contentContainer": `mwCguRDoT3d4H_byub1Y`,
	"textSection": `Ao8zN5hBrJxEGImTs01u`,
	"title": `G9483DMANHPStOMHl1tt`,
	"description": `IK5CevRzk_i_5hV5CoRk`,
	"highlightedText": `wBg4fTATs6vpuvz1zROn`,
	"infoIcon": `sNMfcH1Vx43lL9RDRcGC`,
	"list": `Zr_Bi4WmxH96x2IXZeNT`,
	"highlightedTextRules": `PttwSJIBndMaCdZRox9H`,
	"noWrap": `lke_QCnknQn7EvnRfPhv`,
	"italicText": `x1Bw2JTk6XqgUACmrBFA`,
	"styledSpan": `DIfkV0TPYRpUnTjrSicD`,
	"modalContainer": `pmyvemWcAl7ecust2SPQ`,
	"modalContentWrapper": `fNq2gi_Ryjxg1_AgArFQ`,
	"modalTitle": `rAWgNd9KQqswEDRARB1g`,
	"termsText": `kVCsPeC1xhOAPIc8Lvfv`,
	"closeModalIcon": `Gfwjf1ThzcKUndvrFWeB`
};
export default ___CSS_LOADER_EXPORT___;
